export default __webpack_public_path__ + "static/media/role-success-img.0bbdab03.png";